import React from 'react';

export const AddTask = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_157_917)">
            <path
                d="M10.5527 1.33333C10.4139 0.943877 10.1583 0.606774 9.82073 0.368115C9.48315 0.129456 9.08009 0.000891662 8.66667 0L7.33333 0C6.91991 0.000891662 6.51685 0.129456 6.17927 0.368115C5.84169 0.606774 5.58606 0.943877 5.44733 1.33333H2V14C2 15.1027 2.89733 16 4 16H12C13.1027 16 14 15.1027 14 14V1.33333H10.5527ZM12.6667 14C12.6667 14.3673 12.368 14.6667 12 14.6667H4C3.632 14.6667 3.33333 14.3673 3.33333 14V2.66667H6.66667V2C6.66667 1.63267 6.96533 1.33333 7.33333 1.33333H8.66667C9.03467 1.33333 9.33333 1.63267 9.33333 2V2.66667H12.6667V14ZM4.96133 7.674L4.008 6.77133L4.92467 5.80333L5.778 6.612L7.47667 4.914L8.41933 5.85667L6.62467 7.65133C6.40574 7.87242 6.10874 7.99867 5.79764 8.00291C5.48653 8.00715 5.1862 7.88903 4.96133 7.674ZM8.42 9.856L6.62533 11.6507C6.40641 11.8717 6.10941 11.998 5.7983 12.0022C5.4872 12.0065 5.18687 11.8884 4.962 11.6733L4.00867 10.7707L4.92533 9.80267L5.77867 10.6113L7.47733 8.91333L8.42 9.856ZM8 8L9.36133 6.66667H11.3333V8H8ZM9.36133 10.6667H11.3333V12H8L9.36133 10.6667Z"
                fill="#252733"
            />
        </g>
        <defs>
            <clipPath id="clip0_157_917">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
